export default __webpack_public_path__ + "static/media/paper_blockchain_2016.89fbf4ed.png";